import { render, staticRenderFns } from "./QuoteItems.vue?vue&type=template&id=b65ffa30&scoped=true&"
import script from "./QuoteItems.vue?vue&type=script&lang=ts&"
export * from "./QuoteItems.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteItems.vue?vue&type=style&index=0&id=b65ffa30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ffa30",
  null
  
)

export default component.exports